import React from 'react'

const FeedPoster = () => (
  <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="poster">
        <rect className="holder" stroke="#121212" x="0.5" y="0.5" width="19" height="19" rx="2" />
        <rect className="thumb" fill="#121212" x="6" y="0" width="8" height="20" rx="2" />
      </g>
    </g>
  </svg>
)

export default FeedPoster
